import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { ToggleButton, ToggleButtonGroup, Box, Button } from '@mui/material';
import AllBillings from './AllBillings';
import PackageAllBill from './PackageAllBill';
import AllDraftBills from './AllDraftBills';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { FaDownload } from 'react-icons/fa';
import 'jspdf-autotable';

const BillingManagement = () => {
    const [billType, setBillType] = useState('Bill');
    const allBillingsRef = useRef();
    const navigate = useNavigate();

    const handleBillTypeChange = (event, newBillType) => {
        if (newBillType) {
            setBillType(newBillType);
        }
    };

       const billTitles = {
        Bill: 'Manage  Bills',
        PackageBills: 'Manage Package Bills',
        AllDraftBills: 'Manage Draft Bills',
        Wallet: 'Manage Wallet Bills'
    };
    
    const handleDownloadBulkPdf = () => {
    if (!allBillingsRef.current) {
        console.error("Export functionality is not available for this bill type.");
        return;
    }
    const exportData = allBillingsRef.current.getExportData();

    if (!Array.isArray(exportData) || exportData.length === 0) {
        console.error('No data to export');
        return;
    }

    const billIds = exportData.map(item => item._id);

    navigate('/bulkbillgenerator', {
        state: {
            billIds,
            billType: billType === 'Wallet' ? 'Wallet' : 'Bill', // or 'package'/'membership' if needed
        },
    });
};
    return (
         <PageContainer
            title={billTitles[billType] || 'Manage Billings'}
            description={`This contains all ${billType}`}
        >
            <DashboardCard2 title={billTitles[billType] || 'Manage Billings'}>
{/* {(billType === 'Bill' || billType === 'Wallet' || billType === 'PackageBills' || billType === 'AllDraftBills') && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        title="Download Bulk Bill PDF"
                        sx={{
                            height: '40px',
                            padding: '0.3rem',
                            '&:hover': { background: '#6174DD' },
                        }}
                        onClick={handleDownloadBulkPdf}
                    >
                        <FaDownload style={{ height: '1.6rem', fontSize: '1.2rem' }} />
                    </Button>
                </div>
                )} */}
                {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem', marginBottom: '1rem' }}>
                    <ToggleButtonGroup
                        value={billType}
                        exclusive
                        sx={{
                            borderRadius: '30px',
                            height: '40px',
                            backgroundColor: '#f0f0f0',
                            width: '60%',
                            border: '1px solid #cfcece',
                        }}
                        onChange={handleBillTypeChange}
                    >
                        {['Bill', 'PackageBills', 'AllDraftBills', 'Wallet'].map((type, index) => (
                            <React.Fragment key={type}>
                                <ToggleButton
                                    value={type}
                                    sx={{
                                        color: '#000',
                                        backgroundColor: '#fafafa',
                                        flex: 1,
                                        borderRadius: '30px',
                                        height: '100%',
                                        border: 'none',
                                        '&.Mui-selected': {
                                            backgroundColor: '#6174DD',
                                            color: '#fff',
                                            border: 'none',
                                            '&:hover': {
                                                backgroundColor: '#6174DD',
                                            },
                                        },
                                        '&:not(.Mui-selected)': {
                                            border: '1px solid transparent',
                                            '&:hover': {
                                                backgroundColor: '#d0d0d0',
                                            },
                                        },
                                    }}
                                >
                                    {type === 'PackageBills'
                                        ? 'Package Bills'
                                        : type === 'AllDraftBills'
                                            ? 'Draft Bills'
                                            : type}
                                </ToggleButton>

                                {type !== 'Wallet' && type !== billType && !(billType === 'Wallet' && type === 'AllDraftBills') && (
                                    <div style={{ height: '39px', width: '3px', backgroundColor: '#cfcece' }} />
                                )}
                            </React.Fragment>
                        ))}
                    </ToggleButtonGroup>
                </div> */}

                {/* {New-ui-toggle} */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '1rem 0',
                    width: '100%'
                }}>
                    <ToggleButtonGroup
                        value={billType}
                        exclusive
                        sx={{
                            width: '90%',
                            maxWidth: '880px',
                            backgroundColor: 'transparent',
                            gap: '8px',
                            '& .MuiToggleButtonGroup-grouped': {
                                border: 0,
                                '&:not(:first-of-type)': {
                                    borderRadius: '8px',
                                    marginLeft: '0px'
                                },
                                '&:first-of-type': {
                                    borderRadius: '8px'
                                }
                            }
                        }}
                        onChange={handleBillTypeChange}
                    >
                        {['Bill', 'PackageBills', 'AllDraftBills', 'Wallet'].map((type) => (
                            <ToggleButton
                                key={type}
                                value={type}
                                sx={{
                                    flex: 1,
                                    py: 1,
                                    px: 2,
                                    textTransform: 'none',
                                    fontSize: '0.875rem',fontWeight: 600,
                                    color: '#4A4A4A',
                                    backgroundColor: '#F5F5F5',
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '8px !important',
                                    transition: 'all 0.3s ease',
                                    '&.Mui-selected, &.Mui-selected:hover': {
                                        color: '#FFFFFF',
                                        backgroundColor: '#6174DD',
                                        borderColor: '#6174DD',
                                        boxShadow: '0 2px 8px rgba(97, 116, 221, 0.3)'
                                    },
                                    '&:hover': {
                                        backgroundColor: '#E8EAF6',
                                        borderColor: '#D1D5F0'
                                    },
                                    '&:not(:last-child)': {
                                        marginRight: '10px'
                                    }
                                }}
                            >
                                {type === 'PackageBills' ? 'Memberships / Packages' :
                                    type === 'AllDraftBills' ? 'Drafts' :
                                        type}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </div>
                <Box>
                    {billType === 'Bill' && <AllBillings billType={billType} ref={allBillingsRef} />}
                    {billType === 'Wallet' && <AllBillings billType={billType} ref={allBillingsRef} />}
                    {billType === 'PackageBills' && <PackageAllBill />}
                    {billType === 'AllDraftBills' && <AllDraftBills />}
                </Box>
            </DashboardCard2>
        </PageContainer>
    );
};

export default BillingManagement;